module.exports = __webpack_public_path__ + "static/media/miles-down-arrow.808519a6.svg";